import { Typography } from "@material-ui/core";
import { fetchCustomerBookings } from "actions/customers";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import { Alert } from '@material-ui/lab'
import CustomSelect from "components/custom/CustomSelect/CustomSelect";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Loading from "components/Loading/Loading";
import Pagination from "components/Pagination/Pagination";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomerBookingCard from "./CustomerBookingCard";
import { fetchOrganizationsByBusinessAdminId } from "actions/organization";
import DateRangePicker from "components/custom/DateRangePicker/DateRangePicker";
import moment from "moment-timezone";

const CustomerBookingHistory = ({ customerId }) => {

    const dispatch = useDispatch();
    const bookingList = useSelector(state => state.customers.bookingList);
    const bookingsLoading = useSelector(state => state.customers.bookingsLoading);
    const organizations = useSelector(state => state.organization.organizations);

    const [displayList, setDisplayList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [pageSize, setPageSize] = useState(25);
    const [pageNumber, setPageNumber] = useState(0);
    const [totalNumberOfItems, setTotalNumberOfItems] = useState(0);

    const [startSec, setStartSec] = useState(null);
    const [endSec, setEndSec] = useState(null);
    const [showCustomDateSelector, setShowCustomDateSelector] = useState(false);
    const [dateRange, setDateRage] = useState('all');
    const [customDateRangeApplied, setCustomDateRangeApplied] = useState("");
    const dateRangeOptions = [
        { label: 'All Time', key: 'all', value: 'all' },
        { label: 'Next 7 days', key: 'next_7', value: 'next_7' },
        { label: 'Next 30 days', key: 'next_30', value: 'next_30' },
        { label: 'Next 90 days', key: 'next_90', value: 'next_90' },
        { label: 'Past 7 days', key: 'past_7', value: 'past_7' },
        { label: 'Past 30 days', key: 'past_30', value: 'past_30' },
        { label: 'Past 90 days', key: 'past_90', value: 'past_90' },
        { label: 'Custom', key: 'custom', value: 'custom' },
    ];

    const fetchPaginatedCustomerBookings = async () => {
        const orgId = organizations?.[0]?.id;
        const paginationParams = `pageNumber=${pageNumber}&pageSize=${pageSize}&includeSummary=true`
        const orgParams = orgId ? `&orgId=${orgId}` : '';
        const dateFilter = startSec && endSec ? `&startSec=${moment(startSec).unix()}&endSec=${moment(endSec ).unix()}` : '';
        const queryParams = `${paginationParams}${orgParams}${dateFilter}`
        const responseData = await dispatch(fetchCustomerBookings(customerId, queryParams));
        //console.log(responseData);
        if (responseData?.totalNumberOfItems) {
            setTotalNumberOfItems(responseData?.totalNumberOfItems);
        }
    }

    const handleDateRange = (value) => {
        if (value == "custom") { //custom
            setShowCustomDateSelector(true);
            //setDateRage(value);
            return;
        }
        setDateRage(value);
        setCustomDateRangeApplied("");

        switch (value) {
            case "all":
                setStartSec(null);
                setEndSec(null);
                break;
            case "next_7":
                setStartSec(moment().startOf('day'));
                setEndSec(moment().add(7, 'days').endOf('day'));
                break;
            case "next_30":
                setStartSec(moment().startOf('day'));
                setEndSec(moment().add(30, 'days').endOf('day'));
                break;
            case "next_90":
                setStartSec(moment().startOf('day'));
                setEndSec(moment().add(90, 'days').endOf('day'));
                break;
            case "past_7":
                setStartSec(moment().subtract(7, 'days').startOf('day'));
                setEndSec(moment().endOf('day'));
                break;
            case "past_30":
                setStartSec(moment().subtract(30, 'days').startOf('day'));
                setEndSec(moment().endOf('day'));
                break;
            case "past_90":
                setStartSec(moment().subtract(90, 'days').startOf('day'));
                setEndSec(moment().endOf('day'));
                break;
        }
    }


    useEffect(() => {
        const orgId = organizations?.[0]?.id;
        if (customerId && orgId && dateRange !== "custom") {
            fetchPaginatedCustomerBookings();
        }
    }, [pageNumber, pageSize, customerId, organizations, dateRange]);

    useEffect(() => {
        setDisplayList(bookingList)
    }, [bookingList])

    useEffect(() => {
        setIsLoading(bookingsLoading)
    }, [bookingsLoading])

    useEffect(() => {
        if (!organizations?.length) {
            dispatch(fetchOrganizationsByBusinessAdminId());
        }
    }, []);

    return (
        <>
            {isLoading ? <Loading />
                : displayList?.length ?
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardBody>
                                    <GridContainer alignItems="center" justifyContent="space-between">
                                        <GridItem>
                                            <Pagination
                                                pages={[
                                                    {
                                                        text: "Previous",
                                                        onClick: () => setPageNumber(prev => prev <= 0 ? prev : prev - 1),
                                                        disabled: pageNumber <= 0,
                                                        active: true,
                                                    },
                                                    {
                                                        text: `${pageNumber * pageSize} - ${Math.min(pageNumber * pageSize + pageSize, totalNumberOfItems)} of ${totalNumberOfItems}`,
                                                        active: false,
                                                        onClick: () => { },
                                                        style: { textTransform: 'none' },
                                                        disabled: true,
                                                    },
                                                    {
                                                        text: "Next",
                                                        onClick: () => setPageNumber(prev => prev >= parseInt(totalNumberOfItems / pageSize) ? prev : prev + 1),
                                                        disabled: pageNumber >= parseInt(totalNumberOfItems / pageSize) ? true : false,
                                                        active: true,
                                                    },
                                                ]}
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <GridContainer alignItems="center" justifyContent="flex-end">
                                                <GridItem>
                                                    <CustomSelect
                                                        id="dateRange"
                                                        labelText="Date Range"
                                                        selectProps={{
                                                            value: dateRange,
                                                            onChange: e => handleDateRange(e?.target?.value),
                                                            name: "dateRange",
                                                            inputProps: { name: "userdateRangeType" },
                                                            displayEmpty: true,
                                                            renderValue: (value) => {
                                                                return (customDateRangeApplied ? customDateRangeApplied : dateRangeOptions.find(item => item.value == value)?.label)
                                                            }
                                                        }}
                                                        menuOptions={dateRangeOptions}
                                                        formControlProps={{ fullWidth: true }}
                                                        labelProps={{ shrink: true }}
                                                    />
                                                    <DateRangePicker
                                                        title={"Select start and end dates"}
                                                        showPicker={showCustomDateSelector}
                                                        onClose={() => { setShowCustomDateSelector(false); }}
                                                        initialStartDate={startSec ?? moment().startOf('day')}
                                                        initialEndDate={endSec ?? moment().endOf('day')}
                                                        onApply={(start, end) => {
                                                            setStartSec(moment(start * 1000));
                                                            setEndSec(moment(end * 1000));
                                                            setCustomDateRangeApplied(`${moment(start * 1000).format("Do MMM YYYY")} - ${moment(end * 1000).format("Do MMM YYYY")}`);
                                                            setDateRage("");
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem>
                                                    <CustomSelect
                                                        id="pageSize"
                                                        labelText="Number of Rows"
                                                        selectProps={{
                                                            value: pageSize,
                                                            onChange: e => { setPageNumber(0); setPageSize(e.target.value) },
                                                            name: "pageSize",
                                                            style: { minWidth: 150 }
                                                        }}
                                                        menuOptions={
                                                            [
                                                                { label: '10', key: '10', value: 10 },
                                                                { label: '25', key: '25', value: 25 },
                                                                { label: '50', key: '50', value: 50 },
                                                                { label: '100', key: '100', value: 100 },
                                                            ]}
                                                        formControlProps={{ fullWidth: true }}
                                                    />
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer justifyContent="center">
                                        {displayList.map(booking =>
                                            <GridItem xs={12} md={12}>
                                                <CustomerBookingCard booking={booking} />
                                            </GridItem>
                                        )
                                        }
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                    :
                    <GridContainer justifyContent="center">
                        <GridItem>
                            <Alert severity="info">{`There is no customer bookings found`} </Alert>
                        </GridItem>
                    </GridContainer>
            }
        </>
    )
}

export default CustomerBookingHistory;